import useInfiniteScroll from 'react-infinite-scroll-hook'

import { useEffect, useRef } from 'react'
import { useRouter } from 'next/router'
import { ComponentState, UserState } from '@/states'
import { List } from '@/controllers/component'

const useComponents = () => {
    const { User } = UserState()
    const { push } = useRouter()

    const {
        Components,
        SetState,
        Loading,
        Filters,
        HasMore
    } = ComponentState()

    const AbortControllerReference = useRef<AbortController | null>(null)

    const LoadMore = () => {
        const allow = User?.hasOwnProperty('_id')

        if (allow) {
            if (AbortControllerReference.current) {
                AbortControllerReference.current.abort()
                AbortControllerReference.current = null
            }

            List(
                SetState,
                Filters,
                Components,
                AbortControllerReference,
                push
            )
        }
    }

    const [InfiniteEndReference] = useInfiniteScroll({
        loading: Loading,
        hasNextPage: HasMore,
        onLoadMore: LoadMore,
        rootMargin: '0px 0px 800px 0px'
    })

    useEffect(() => {
        SetState({
            Components: [],
            Loading: true,
            Error: false,
            Deleting: null,
            HasMore: true
        })
    }, [User, Filters])

    useEffect(() => {
        SetState({
            Components: [],
            Loading: true,
            Error: false,
            Deleting: null,
            HasMore: true
        })
    }, [])

    useEffect(() => {
        if (Components.length === 0 && HasMore) LoadMore()
    }, [Components, HasMore])

    return {
        Components,
        Loading,
        InfiniteEndReference
    }
}

export default useComponents
